import { AppRoutes } from '../app-routes';
import { SnackbarStateUI } from '../interfaces/snackbar-state.interface';
import { TextErrorContentUI } from '../interfaces/text-content.interface';
import { TextModalContentUI } from '../interfaces/text-modal.interface';
import { ClickEventTags, PageEventTags, SnackbarEventTags } from '../services/gtm/gtm-types';
import { Links } from './constants';
import { ErrorContentName, ModalContentKey, SnackbarMessageKey, snackbarType } from './enums';

export const ErrorTexts: Record<ErrorContentName, TextErrorContentUI> = {
	[ErrorContentName.GENERIC_ERROR]: {
		errorName: ErrorContentName.GENERIC_ERROR,
		asset: 'assets/images/bank-red.svg',
		title: 'Ocurrió un problema al cargar',
		description: 'Por ahora, no es posible mostrar esta información. Por favor, inténtalo más tarde.',
		button: {
			text: 'Entendido',
			action: Links.institutional.bciPyme,
		},
		tags: {
			page: PageEventTags.genericError,
			action: ClickEventTags.genericError,
		},
	},
	[ErrorContentName.NO_CONNECTION]: {
		errorName: ErrorContentName.NO_CONNECTION,
		asset:
			'data:image/svg+xml;base64,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',
		title: 'Sin conexión a internet',
		description: 'Intenta acceder cuando vuelvas a tener conexión.',
		button: {
			text: 'Entendido',
			action: Links.institutional.bciPyme,
		},
	},
	[ErrorContentName.OTP_LIMIT]: {
		errorName: ErrorContentName.OTP_LIMIT,
		asset: 'assets/images/padlock-error.svg',
		title: 'Ocurrió un problema con tu verificación de datos',
		description: 'Has superado los 3 intentos permitidos para ingresar el código',
		button: {
			text: 'Ir al Inicio',
			action: Links.institutional.bciPyme,
		},
		tags: {
			page: PageEventTags.verificationError,
			action: ClickEventTags.verificationError,
		},
	},
	[ErrorContentName.INELIGIBLE_CUSTOMER]: {
		errorName: ErrorContentName.INELIGIBLE_CUSTOMER,
		asset: 'assets/images/bank-red.svg',
		title: 'Encuentra la mejor forma de simular',
		description:
			'Por ahora, no podemos atender tu solicitud. Si eres cliente simula en tu Banco en Línea. Si aún no eres cliente, puedes volver a intentarlo.',
		button: {
			text: 'Entendido',
			action: Links.institutional.bciPyme,
		},
		tags: {
			page: PageEventTags.bciClientError,
			action: ClickEventTags.bciClientError,
		},
	},
	[ErrorContentName.INVALID_TAX_FOLDER_PASSWORD]: {
		errorName: ErrorContentName.INVALID_TAX_FOLDER_PASSWORD,
		asset: 'assets/images/bank-blue.svg',
		title: 'No pudimos sincronizar tu carpeta tributaria',
		description:
			'Podrás continuar con tu simulación. Te recomendamos que reintentes sincronizar tu carpeta más adelante para acceder a ofertas personalizadas.',
		button: {
			text: 'Continuar',
			action: AppRoutes.OTP,
		},
	},
	[ErrorContentName.PURPOSES_ERROR]: {
		errorName: ErrorContentName.PURPOSES_ERROR,
		asset: 'assets/images/bank-red.svg',
		title: 'Encuentra la mejor forma de simular',
		description:
			'Por ahora, no podemos atender tu solicitud. Si eres cliente simula en tu Banco en Línea. Si aún no eres cliente, puedes volver a intentarlo.',
		button: {
			text: 'Entendido',
			action: AppRoutes.COMPANY_DATA,
		},
	},
};

export const SnackbarTexts: Record<SnackbarMessageKey, SnackbarStateUI> = {
	[SnackbarMessageKey.OTP_SENT]: {
		autoHide: true,
		type: snackbarType.SUCCESS,
		message: 'El código ha sido reenviado con éxito.',
		tag: SnackbarEventTags.resendCode,
	},
	[SnackbarMessageKey.OTP_EXPIRED]: {
		autoHide: true,
		type: snackbarType.WARNING,
		message: 'El tiempo se ha agotado, reenvía el código',
		tag: SnackbarEventTags.expiredCode,
	},
	[SnackbarMessageKey.VALIDATION_ERROR]: {
		autoHide: true,
		type: snackbarType.ERROR,
		message: 'El código ingresado es incorrecto. {{attemptMsg}}',
		tag: SnackbarEventTags.incorrectCode,
	},
	[SnackbarMessageKey.CTE_PASSWORD_ERROR]: {
		autoHide: true,
		type: snackbarType.ERROR,
		message: 'La clave ingresada es incorrecta. Te queda 1 intento.',
	},
};

export const ModalTexts: Record<ModalContentKey, TextModalContentUI> = {
	[ModalContentKey.ABANDON_MODAL]: {
		type: ModalContentKey.ABANDON_MODAL,
		asset: 'assets/images/bank-alert.svg',
		title: '¿Estás seguro que deseas abandonar?',
		description: 'Perderás el avance de tu simulación.',
		primaryButton: {
			text: 'Continuar simulación',
		},
		tertiaryButton: {
			text: 'Salir',
			action: Links.institutional.bciPyme,
		},
		tags: {
			page: PageEventTags.leakModal,
			actions: {
				primaryAction: ClickEventTags.leakContinue,
				tertiaryAction: ClickEventTags.leakGoOut,
				default: ClickEventTags.leakContinue,
			},
		},
	},
};
